/**
 * Show a browser notification when onboarding is completed or skipped
 * and there's no redirect URI to navigate to
 */
export function showOnboardNotification(type: 'Complete' | 'Skipped'): void {
  const message = `Onboard ${type} - You may now close this window.`;

  // Try to use the Notifications API first
  if ('Notification' in window) {
    // Check if permission is already granted
    if (Notification.permission === 'granted') {
      new Notification(message, {
        icon: '/favicon.ico',
        badge: '/favicon.ico',
      });
      return;
    }

    // Request permission if not already determined
    if (Notification.permission !== 'denied') {
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          new Notification(message, {
            icon: '/favicon.ico',
            badge: '/favicon.ico',
          });
        } else {
          // Fallback to alert if permission denied
          alert(message);
        }
      });
      return;
    }
  }

  // Fallback to alert if Notifications API not available or permission denied
  alert(message);
}
